var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { usePortals } from '@molecules/BEPortal';
const useOffScreen = (Component, OffScreenProps, type) => {
    const { id } = OffScreenProps, offscreenProps = __rest(OffScreenProps, ["id"]);
    const { open: openPortal, close: closePortal, has } = usePortals();
    const [tag, setTag] = useState(undefined);
    const [currentProps, setCurrentProps] = useState(OffScreenProps);
    const offscreenId = id || 'offscreen';
    const _a = offscreenProps || {}, { onCancel } = _a, props = __rest(_a, ["onCancel"]);
    const onCancelProxy = useCallback((portal) => onCancel ? () => onCancel(portal) : portal.close, [onCancel]);
    const portal = useMemo(() => ({ close: () => closePortal(offscreenId) }), [offscreenId, closePortal]);
    return useMemo(() => ({
        close: portal.close,
        isOpened: () => has(offscreenId),
        open: (openProps) => {
            setTag(openProps === null || openProps === void 0 ? void 0 : openProps.tag);
            setCurrentProps(Object.assign({ id: offscreenId }, OffScreenProps));
            openPortal(_jsx(Component, Object.assign({}, Object.assign(Object.assign(Object.assign({}, openProps), props), { onCancel: onCancelProxy(portal) }))), {
                id: offscreenId,
                type,
            });
        },
        props: currentProps,
        tag,
    }), [
        openPortal,
        OffScreenProps,
        Component,
        offscreenId,
        onCancelProxy,
        currentProps,
        portal,
        has,
        tag,
        type,
        props,
    ]);
};
export const useModal = (Component, Props) => {
    return useOffScreen(Component, Props !== null && Props !== void 0 ? Props : {}, 'modal');
};
export const usePopover = (Component, Props) => {
    return useOffScreen(Component, Props !== null && Props !== void 0 ? Props : {}, 'popover');
};
